import { forwardRef, memo, useState, useEffect } from "react";
import ReactDOMServer from 'react-dom/server';
import { useMap } from "react-leaflet";
import { useDispatch } from "react-redux";
import { CommonConst as Consts } from "../../../../../shared/common-utilities/enums/CommonConst.jsx";
import dataStorageService from "../../../../../shared/common-utilities/services/DataStorageService.jsx";
import getSetDataService from "../../../../../shared/common-utilities/services/getSetDataService";
import MarkerSvgIcon from "../../../../../shared/common-utilities/utils/MarkerSvgIcon";
import { areaSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/areaSelectionReducer";
import { listSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/listSelectionReducer";

let service = getSetDataService();
const storageService = dataStorageService();
// let lassoControl = null;
let lasso = null;

const LassoSelection = memo(({ enableLasso }) => {
    const map = useMap();
    const dispatch = useDispatch();
    lasso = lasso ? lasso : L.lasso(map, { intersect: true });
    // useEffect(() => { lassoControl = L.control.lasso().addTo(map); }, [])
    useEffect(() => {
        if (enableLasso) {
            lasso.enable();
        } else {
            if (lasso.enabled) {
                lasso.disable();
                map.off('lasso.finished')
            }
        }
    }, [enableLasso]);

    useEffect(() => {
        if (!enableLasso) {
            map.off('lasso.finished')
        } else {
            const dispatchSelection = (selectedData) => {
                let movementIds = [];
                const getListSelection = storageService.getLocalStorageData('listSelection');
                let existingListSelection = getListSelection ? JSON.parse(getListSelection) : [];

                if (!existingListSelection.movementIds) existingListSelection.movementIds = [];
                if (!existingListSelection.partialTripIds) existingListSelection.partialTripIds = [];
                if (!existingListSelection.routeIds) existingListSelection.routeIds = [];

                movementIds = selectedData.filter(x => x.isSelection && x.source === Consts.Movements).map(x => x.id);
                existingListSelection.movementIds = movementIds.length > 0 ? _.uniq([...existingListSelection.movementIds, ...movementIds]) : existingListSelection.movementIds;

                dispatch(listSelectionReducer(existingListSelection));
                storageService.setLocalStorageData('listSelection', JSON.stringify(existingListSelection));
            };

            map.on('lasso.finished', (event) => {
                let selectedData = [];
                const layersKeys = _.entries(map._layers).filter(x => x[1]?.options?.item != undefined).map(p => p[0]);
                for (const key of layersKeys) {
                    const layer = map._layers[key];

                    if (layer?.options?.item) {
                        const element = event?.layers.find(e => e?.options?.item?.id == layer?.options?.item?.id);
                        if (element) {
                            const { id, source, subid } = element?.options?.item;
                            if (source != Consts.PartialTrips) {
                                if ((layer.options?.item?.id === id)) {
                                    layer.options.item.selected = true;
                                    layer.options.selected = true;
                                    let newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                                    layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : layer?.options?.initColor) }) : layer?.setIcon(newIcon);
                                    selectedData.push({ type: 'marker', id: id, subid: subid, isSelection: layer.options.selected, source: source });
                                } else {
                                    layer.options.item.selected = false;
                                    layer.options.selected = false
                                    let newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                                    layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : layer?.options?.initColor) }) : layer?.setIcon(newIcon);
                                }
                            }
                        } else {
                            layer.options.item.selected = false;
                            layer.options.selected = false
                            if (layer?.options?.item?.source != Consts.PartialTrips) {
                                let newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                                layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : layer?.options?.initColor) }) : layer?.setIcon(newIcon);
                            } else {
                                let newIcon = service.createCustomIcon(null, map.getZoom(), layer.options?.item?.sequenceNo, layer.options?.item?.selected);
                                // let newIcon = service.createCustomIcon(null, service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected));
                                layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : layer?.options?.initColor) }) : layer?.setIcon(newIcon);
                            }
                        }
                    }
                }
                dispatch(areaSelectionReducer({ layersData: _.uniqBy(selectedData, 'id') }));
                dispatchSelection(selectedData);
            });
        }

        // map.on('lasso.enabled', () => { });
        // map.on('lasso.disabled', () => { });

        return () => {
            map.off('lasso.finished');
        };
    }, [enableLasso]);

    return null;
});

export default LassoSelection;